import $ from 'jquery'
import select2Delimited from '@/ui/dropdown/select2-delimited'

export const initializeSubstrates = () => {
  select2Delimited.basicDelimiter($('.product-substrates select'))
}
